import { handleActions } from 'redux-actions';
import * as Actions from '../actions/loadingActions';

const app = handleActions({
  [Actions.setIsLoading]: (state, action) => ({
    ...state,
    isLoading: action.payload,
  }),
  [Actions.setErrorMessage]: (state, action) => {
    if (action.payload === null || action.payload === '') {
      return ({
        ...state,
        errorMessage: null,
        alert: false,
      });
    }
    return ({
      ...state,
      errorMessage: (typeof action.payload === 'string') ? action.payload : action.payload.message,
    });
  },
  [Actions.setAlert]: (state, action) => ({
    ...state,
    errorMessage: !action.payload ? null : state.errorMessage,
    alert: action.payload,
  }),
  [Actions.toggleAlert]: (state) => ({
    ...state,
    errorMessage: state.alert ? null : state.errorMessage,
    alert: !state.alert,
  }),
  [Actions.setProgress]: (state, action) => ({
    ...state,
    progress: action.payload,
  }),
  [Actions.setPause]: (state, action) => ({
    ...state,
    pause: action.payload,
  }),
}, {
  isLoading: false,
  errorMessage: null,
  alert: false,
  progress: 0,
  remainedTime: 0,
  pause: false,
});

export default app;
